import { render, staticRenderFns } from "./StakedStatus.vue?vue&type=template&id=29036d73&scoped=true"
import script from "./StakedStatus.vue?vue&type=script&lang=js"
export * from "./StakedStatus.vue?vue&type=script&lang=js"
import style0 from "./StakedStatus.vue?vue&type=style&index=0&id=29036d73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29036d73",
  null
  
)

export default component.exports